import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useDarkMode } from '../context/DarkModeContext';
import Footer from '../components/Footer';
import '../styles/HomePage.css';

const tools = [
  {
    id: 'text-compare',
    title: 'Text Compare',
    description: 'Compare two texts side-by-side and highlight every difference with character-level precision.',
    icon: '📝',
    available: true
  },
  {
    id: 'text-checker',
    title: 'Text Checker',
    description: 'Count words, characters, and sentences. Detect special chars, change case, and clean up text.',
    icon: '✔️',
    available: true
  },
  {
    id: 'json-validator',
    title: 'JSON Validator',
    description: 'Validate, format, and explore JSON data. Convert JSON arrays to CSV with one click.',
    icon: '🔍',
    available: true
  },
  {
    id: 'json-compare',
    title: 'JSON Compare',
    description: 'Compare two JSON objects and visualize structural differences at every level.',
    icon: '⚖️',
    available: true
  },
  {
    id: 'markdown-preview',
    title: 'Markdown Preview',
    description: 'Write and preview Markdown in real-time with syntax formatting and live rendering.',
    icon: '📄',
    available: true
  },
  {
    id: 'uuid-generator',
    title: 'UUID Generator',
    description: 'Generate RFC 4122 v4 UUIDs in bulk. Copy individually or all at once.',
    icon: '🔑',
    available: true
  },
  {
    id: 'password-generator',
    title: 'Password Generator',
    description: 'Create strong passwords with custom length, uppercase, numbers, and special characters.',
    icon: '🔐',
    available: true
  },
  {
    id: 'cron-expression',
    title: 'Cron Expression',
    description: 'Decode cron expressions into plain English or build them visually. See next run times.',
    icon: '⏱️',
    available: true
  }
];

export default function HomePage() {
  const navigate = useNavigate();
  const { darkMode, toggleDarkMode } = useDarkMode();

  return (
    <div className={`home-container ${darkMode ? 'dark-theme' : ''}`}>

      {/* ── Dark mode toggle ── */}
      <button
        onClick={toggleDarkMode}
        className="dark-mode-toggle"
        style={{
          position: 'fixed',
          top: '16px',
          right: '16px',
          zIndex: 1000,
          color: '#fff',
          fontSize: '0.9rem',
          padding: '7px 14px',
          borderRadius: '6px',
          backgroundColor: '#1976d2',
          border: 'none',
          cursor: 'pointer',
          display: 'flex',
          alignItems: 'center',
          boxShadow: '0 2px 8px rgba(0,0,0,0.2)'
        }}
        onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#1565c0'}
        onMouseLeave={(e) => e.currentTarget.style.backgroundColor = '#1976d2'}
      >
        <span className="dark-mode-text">{darkMode ? '☀️ Light Mode' : '🌙 Dark Mode'}</span>
        <span className="dark-mode-icon">{darkMode ? '☀️' : '🌙'}</span>
      </button>

      {/* ── Page hero ── */}
      <div className="home-hero">
        <div className="home-hero-inner">
          <img src="/favicon.png" alt="UsefulToolz" className="home-hero-logo" />
          <div className="home-hero-text">
          <h1 className="home-hero-heading">UsefulToolz — Free Online Tools</h1>
            <p className="home-hero-sub">
              Runs entirely in your browser — your data never leaves your device.
            </p>
            <p className="home-hero-eyebrow"> Free ·  Private ·  No Sign-up</p>
          </div>
        </div>
      </div>

      {/* ── Tools grid ── */}
      <div className="tools-section">
        <p className="tools-section-title">Available Tools — {tools.length} tools</p>
        <div className="tools-grid">
          {tools.map((tool) => (
            <div
              key={tool.id}
              className={`tool-card ${!tool.available ? 'coming-soon' : ''}`}
              onClick={() => tool.available && navigate(`/${tool.id}`)}
            >
              <div className="tool-icon-wrapper">
                <span className="tool-icon">{tool.icon}</span>
                <span className="tool-card-label">Tool</span>
              </div>
              <div className="tool-body">
                <h2 className="tool-title">{tool.title}</h2>
                <p className="tool-description">{tool.description}</p>
                {tool.available ? (
                  <span className="tool-action">Open tool →</span>
                ) : (
                  <span className="coming-soon-badge">Coming Soon</span>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>

      <Footer />
    </div>
  );
}
